function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown';
var propTypes = {
  children: PropTypes.node
};
function ButtonDropdown(props) {
  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    group: true
  }, props));
}
ButtonDropdown.propTypes = propTypes;
export default ButtonDropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactstrap/esm/ButtonDropdown.js
// module id = 207
// module chunks = 0